import { Link, useLoaderData, useLocation } from 'react-router-dom';
import { ProviderData } from '@/common/types';
import { Container, Row, Col, Badge, Image } from 'react-bootstrap';
import BioText from '@/common/components/BioText';

const ProviderPage = () => {
  const provider = useLoaderData() as ProviderData;
  const location = useLocation();
  const fromSearch = location.state?.fromSearch;

  return (
    <>
      <section className="bg-light py-5">
        <Container>
          {fromSearch && (
            <div className="mb-4">
              <Link
                to={{
                  pathname: '/providers',
                  search: `?state_code=${fromSearch.stateCode}&insurance_company_name=${fromSearch.insuranceCompanyName}`,
                }}
                className="link-primary"
              >
                ← Back to Provider Search
              </Link>
            </div>
          )}
          <Row className="align-items-center">
            <Col sm={12} md={4} lg={3} className="mb-3 mb-md-0">
              <Image
                src={provider.photoUrl || '/images/placeholder-avatar.svg'}
                alt={`${provider.firstName} ${provider.lastName}`}
                className="rounded-5 shadow-lg mx-auto d-block"
                style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
              />
            </Col>
            <Col sm={12} md={8} lg={9}>
              <h2>
                {provider.firstName} {provider.lastName}
              </h2>
              <div className="mb-2 text-muted">
                {provider.credentials.map((cred) => (
                  <span key={cred.id} className="me-2">
                    {cred.abbreviation}
                  </span>
                ))}
              </div>
              {provider.appointmentSchedulingUrl && (
                <a
                  href={provider.appointmentSchedulingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Book Appointment
                </a>
              )}
            </Col>
          </Row>
        </Container>
      </section>

      {provider.bio && (
        <section className="bg-light-subtle py-5">
          <Container>
            <Row className="mb-4">
              <Col>
                <h4>About</h4>
                <BioText text={provider.bio} />
              </Col>
            </Row>
          </Container>
        </section>
      )}

      <section className="py-5">
        <Container>
          <Row>
            <Col md={6}>
              <h5>Licensed States</h5>
              {provider.states.map((state) => (
                <Badge key={state.code} bg="secondary" className="me-1">
                  {state.code}
                </Badge>
              ))}
            </Col>
            <Col md={6}>
              <h5>Accepted Insurance</h5>
              {provider.insuranceCompanies.map((ins) => (
                <Badge key={ins.name} bg="primary" className="me-1">
                  {ins.name}
                </Badge>
              ))}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ProviderPage;
